var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeat5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3a5 5 0 000 10h4a5 5 0 000-10H6zm-.007 4.965l.938.23c.127-.121.263-.222.41-.303.15-.082.364-.122.644-.122.209 0 .393.035.552.107.16.068.291.166.396.293.107.127.187.277.239.45.055.172.083.362.083.57 0 .219-.025.417-.073.596a1.348 1.348 0 01-.215.469.97.97 0 01-.357.303 1.18 1.18 0 01-.512.102c-.218 0-.41-.042-.577-.127a1.008 1.008 0 01-.4-.366 1.505 1.505 0 01-.19-.59H5.778c.02.328.095.62.225.873.13.25.303.462.518.635.214.17.457.298.727.386.273.084.558.127.855.127.397 0 .74-.06 1.03-.181.293-.124.535-.295.727-.513a2.15 2.15 0 00.43-.756 2.84 2.84 0 00.147-.923c0-.368-.05-.699-.147-.992a2.068 2.068 0 00-.425-.752 1.79 1.79 0 00-.678-.473 2.303 2.303 0 00-.899-.166c-.25 0-.474.032-.669.097a2.298 2.298 0 00-.459.19l.195-1.742h2.857V4.39H6.379l-.386 3.574z",
    fill: "#FF9C40"
  })));
}
SvgSeat5.displayName = 'Seat5';
export default SvgSeat5;